export default
  "Politique cookies Solution Éco France — cookies strictement nécessaires, mesure d'audience PostHog (avec consentement), aucun cookie publicitaire tiers. Conforme CNIL & RGPD.";
